import { ArrowLeft, ArrowRight } from "lucide-react";

function paginationItems(page: number, pageCount: number): Array<number | "ellipsis-start" | "ellipsis-end"> {
  if (pageCount <= 7) return Array.from({ length: pageCount }, (_, index) => index + 1);
  const values = [...new Set([1, pageCount, page - 1, page, page + 1].filter((value) => value >= 1 && value <= pageCount))].sort((left, right) => left - right);
  const items: Array<number | "ellipsis-start" | "ellipsis-end"> = [];
  values.forEach((value, index) => {
    if (index > 0 && value - values[index - 1] > 1) items.push(index === 1 ? "ellipsis-start" : "ellipsis-end");
    items.push(value);
  });
  return items;
}

export function PaginationControls({ page, pageCount, total, pageSize, label, onPageChange }: { page: number; pageCount: number; total: number; pageSize: number; label: string; onPageChange: (page: number) => void }) {
  if (pageCount <= 1) return null;
  const firstItem = (page - 1) * pageSize + 1;
  const lastItem = Math.min(page * pageSize, total);
  return (
    <nav className="list-pagination" aria-label={`${label} pagination`}>
      <span className="list-pagination-summary">Showing {firstItem}–{lastItem} of {total} {label}</span>
      <div className="list-pagination-controls">
        <button className="list-pagination-button" onClick={() => onPageChange(page - 1)} disabled={page === 1} aria-label={`Previous ${label} page`}><ArrowLeft size={14} /></button>
        {paginationItems(page, pageCount).map((item) => item === "ellipsis-start" || item === "ellipsis-end"
          ? <span className="list-pagination-ellipsis" key={item}>…</span>
          : <button className={`list-pagination-button${item === page ? " active" : ""}`} key={item} onClick={() => onPageChange(item)} aria-current={item === page ? "page" : undefined}>{item}</button>)}
        <button className="list-pagination-button" onClick={() => onPageChange(page + 1)} disabled={page === pageCount} aria-label={`Next ${label} page`}><ArrowRight size={14} /></button>
      </div>
    </nav>
  );
}
